import React, { useEffect, useState } from 'react'
import useModalGeneric from '../../../hooks/useModalGeneric'
import WhatsappIcon from '../../atoms/whatsapp-icon/whatsapp-icon'
import ModalRetails from '../../molecules/modal-retails/modal-retails'
import ModalPov from '../../molecules/modalPov/modalPov'
import ModalSessionExpired from '../../molecules/modal-session-expired/modal-session-expired'
import Footer from './../footer/footer'
import Header from './../header/header'
import './layout.scss'

const Layout = (props) => {

  const [modalVisibility, setModalVisibility] = useState(false);
  const [modalSession, setModalSession] = useState(false);
  const [isModal, showModal, HideModal] = useModalGeneric(false);
  const [modalServiceError, setmodalServiceError] = useState(null)

  // Trigger to modal by hash
  const validateHashModal = () => {
    if (window.location.hash === "#comprar") {
      setModalVisibility(true)
    }
    if (window.location.hash === "#puntos-de-venta") {
      showModal()
    }
    if (window.location.hash === "#sesion-expirada") {
      setModalSession(true)
    }
  }

  const handleInputChange = () => {

    setmodalServiceError(
      <div className="f-error-service-modal-curtain">
        <div className="f-error-service-modal-info">
          <div className="f-error-service-close" onClick={() => setmodalServiceError(null)}>X</div>
          Lo sentimos, tenemos un error en este momento, inténtalo de nuevo mas tarde.
        </div>
      </div>
    )
  }

  useEffect(() => {
    validateHashModal()
    window.addEventListener("hashchange", validateHashModal, false)
    document.addEventListener("errorServiceModal", handleInputChange);

    return () => {
      window.removeEventListener("hashchange", validateHashModal, false)
      document.removeEventListener("errorServiceModal", handleInputChange);
    }
  }, [])

  return (
    <>
      <Header btnReturn={props.btnReturn} btnReturnRedirection={props.btnReturnRedirection} isFullPage={props.isFullPage} setModalVisibility={setModalVisibility} currentUser={props.currentUser} currentPoints={props.currentPoints} locale={props.locale} handleBannerPaused={props.handleBannerPaused && props.handleBannerPaused} isMobile={props.isMobile} isChangePassword={props.isChangePassword} />
      <div className={`${props.white ? 'f-layout-background-white' : 'f-layout-background'} ${props.isFullPage && 'f-layout-background--fullpage'}`} >
        <main>{props.children}</main>
      </div>
      <Footer isFullPage={props.isFullPage} isMobile={props.isMobile} />
      <WhatsappIcon />
      {/* {locale === "es-CO" || locale === "es-PE" || locale === "es-DO" ? <WhatsappIcon /> : <></>} */}
      {modalServiceError}
      {
        modalVisibility &&
        <ModalRetails hideAction={() => { setModalVisibility(false) }} />
      }
      {
        isModal && !modalVisibility && !modalSession && <ModalPov onClose={HideModal} />
      }
      {
        modalSession && !modalVisibility && !isModal && <ModalSessionExpired onClose={() => { setModalSession(false) }} />
      }
    </>
  )
};

export default Layout;